import axios from "axios";

const instance = axios.create({});

instance.interceptors.request.use(function (request) {
  //
});
instance.interceptors.response.use(function (response) {
  //
});

const r = {
  getArticleList: function (cat_id, page, pageSize) {
    if (pageSize == undefined) pageSize = 10;
    //console.log("getList")
    return axios.get(
      "//jinmao-official.jb2.zgjmdbw.com/api/article?cat_id=" +
        cat_id +
        "&page=" +
        page +
        "&count=" +
        pageSize
    );
  },
  getArticle: function (id) {
    //console.log("getList")
    return axios.get("//jinmao-official.jb2.zgjmdbw.com/api/article/" + id);
  },
  getColumnList: function (type) {
    //console.log("getList")
    return axios.get(
      "//jinmao-official.jb2.zgjmdbw.com/api/column?type=" + type
    );
  },
};

export default r;
